module.exports = __webpack_public_path__ + "static/media/IMG3.8f1ddb18.png";